// extracted by mini-css-extract-plugin
module.exports =  {"category-item":"E30K0dZ","categoryItem":"E30K0dZ"};